var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 14.0968C20.66 14.0968 21.99 12.7568 21.99 11.0968C21.99 9.4368 20.66 8.0968 19 8.0968C17.34 8.0968 16 9.4368 16 11.0968C16 12.7568 17.34 14.0968 19 14.0968ZM11 14.0968C12.66 14.0968 13.99 12.7568 13.99 11.0968C13.99 9.4368 12.66 8.0968 11 8.0968C9.34 8.0968 8 9.4368 8 11.0968C8 12.7568 9.34 14.0968 11 14.0968ZM11 16.0968C8.67 16.0968 4 17.2668 4 19.5968V21.0968C4 21.6468 4.45 22.0968 5 22.0968H17C17.55 22.0968 18 21.6468 18 21.0968V19.5968C18 17.2668 13.33 16.0968 11 16.0968ZM19 16.0968C18.71 16.0968 18.38 16.1168 18.03 16.1468C18.05 16.1568 18.06 16.1768 18.07 16.1868C19.21 17.0168 20 18.1268 20 19.5968V21.0968C20 21.4468 19.93 21.7868 19.82 22.0968H25C25.55 22.0968 26 21.6468 26 21.0968V19.5968C26 17.2668 21.33 16.0968 19 16.0968Z",
    fill: "#8C99B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.a801291c3ccaf5842fb664c02e894053.svg";
export { ForwardRef as ReactComponent };